import React from 'react';
import getMenu from '../api/queries/menus/getMenu';
import createApolloClient from '../api';
import PageLayout from '../components/PageLayout';
import getDoIHaveACasePage from '../api/queries/doIHaveACasePage/getDoIHaveACasePage';
import sanitizeHTML from '../utils/sanitiseHTML';
import { ContactUsSteps } from '../components/ContactUsSteps';

const client = createApolloClient();

const doIHaveACasePage = ({
  desktopHeaderData,
  aboutMenuData,
  toolsMenuData,
  doihaveacasepage,
}) => {
  const indexStatus = {
    indexPage: true,
  };
  const {
    dihacBannerSection,
    dihacDescription,
    dihacCaseDetails,
    dihacYoutubeEmbed,
    grappleSection,
    dihacWhySection,
  } = doihaveacasepage;

  return (
    <>
      <PageLayout
        menuData={desktopHeaderData}
        aboutMenuData={aboutMenuData}
        toolsMenuData={toolsMenuData}
        title="dihac"
        indexStatus={indexStatus}
      >
        <div className="dihac">
          <section className="dihac-banner">
            <div
              className="dihac-banner-image desktop"
              data-bg={dihacBannerSection?.desktopImage?.sourceUrl}
            >
              <div className="dihac-banner__container">
                <p className="dihac-banner__container__title">{dihacBannerSection?.title}</p>
                <p className="subtitle_1">{dihacBannerSection?.paragraph}</p>
                <div className="dihac-banner__cta">
                  <a className="button" href="#dihac-form">
                    {dihacBannerSection?.buttonText}
                  </a>
                </div>
              </div>
            </div>
            <div
              className="dihac-banner-image mobile"
              data-bg={dihacBannerSection?.mobileImage?.sourceUrl}
            >
              <div className="dihac-banner__container">
                <p className="dihac-banner__container__title">{dihacBannerSection?.title}</p>
                <p className="subtitle_1">{dihacBannerSection?.paragraph}</p>
                <div className="dihac-banner__cta">
                  <a className="button" href={dihacBannerSection?.buttonLink}>
                    {dihacBannerSection?.buttonText}
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div
              className="desc"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(dihacDescription) }}
            />
          </section>
          <section id="dihac-form" className='contact-us ms-page'>
            <div className="dihac__cdf cdf2__page first_head">
              <ContactUsSteps />
            </div>
          </section>
          <section className='video-section'>
            <div
              className="youtube"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(dihacYoutubeEmbed) }}
            />
          </section>
          <section>
            <div className="dihac__why-section">
              <h3>{dihacWhySection?.title}</h3>
              <div className="dihac__why-section__col">
                <div className="dihac__why-section__col__1">
                  <img src={dihacWhySection?.image1?.sourceUrl} alt="image" />
                  <p>
                    <b>{dihacWhySection?.title1}</b>
                  </p>
                  <p>{dihacWhySection?.subtitle1}</p>
                </div>
                <div className="dihac__why-section__col__2">
                  <img src={dihacWhySection?.image2?.sourceUrl} alt="image" />
                  <p>
                    <b>{dihacWhySection?.title2}</b>
                  </p>
                  <p>{dihacWhySection?.subtitle2}</p>
                </div>
                <div className="dihac__why-section__col__3">
                  <img src={dihacWhySection?.image3?.sourceUrl} alt="image" />
                  <p>
                    <b>{dihacWhySection?.title3}</b>
                  </p>
                  <p>{dihacWhySection?.subtitle3}</p>
                </div>
              </div>
              <div className="dihac-banner__cta">
                <a className="button" href="#dihac-form">
                  {dihacWhySection?.buttonText}
                </a>
              </div>
            </div>
          </section>
        </div>
      </PageLayout>
    </>
  );
};

export default doIHaveACasePage;

export async function getStaticProps() {
  const desktopHeaderData = await client.query(getMenu('dGVybToyNQ=='));
  const aboutMenuData = await client.query(getMenu('dGVybTo1NQ=='));
  const toolsMenuData = await client.query(getMenu('dGVybTo1Ng=='));
  const { data } = await client.query(getDoIHaveACasePage());
  const { acfOptionsDoihaveacasepage } = data;
  const { doihaveacasepage } = acfOptionsDoihaveacasepage;

  return {
    props: { desktopHeaderData, aboutMenuData, toolsMenuData, doihaveacasepage },
    revalidate: 10,
  };
}
